/** @jsxImportSource @emotion/react */

import {
  ErrorResponse,
  formatErrorResponse,
} from '@quickbit/backoffice-core-frontend';
import { Snackbar, Tooltip, UtilityButton } from '@quickbit/qb-design-system';
import { useState } from 'react';
import { useAsyncFn } from 'react-use';

interface Props {
  disabled?: boolean;
  csvFileName: string;
  exportFunction: () => Promise<Blob>;
  title?: string;
}

export const ExportCsv = ({
  exportFunction,
  disabled,
  csvFileName,
  title,
}: Props) => {
  const [exportError, setExportError] = useState<ErrorResponse>();
  const [{ loading: downloadCsvLoading }, exportCsv] = useAsyncFn(async () => {
    let csvResponse: Blob;
    try {
      csvResponse = await exportFunction();
    } catch (exception) {
      setExportError(exception as ErrorResponse);
      return false;
    }

    const link = document.createElement('a');
    link.href = URL.createObjectURL(csvResponse);
    link.download = csvFileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [exportFunction]);
  return (
    <>
      {exportError != undefined && (
        <Snackbar
          variant="danger"
          message={formatErrorResponse(exportError)}
          open={true}
          onClose={() => setExportError(undefined)}
        />
      )}
      <Tooltip
        title={
          disabled
            ? 'Over maximum limit of users for export.'
            : 'Takes a long time. Do not click around in this tab or reload.'
        }
      >
        <UtilityButton
          text={title || 'Extract as csv'}
          onClick={exportCsv}
          loading={downloadCsvLoading}
          disabled={disabled || downloadCsvLoading}
        />
      </Tooltip>
    </>
  );
};
